var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animations-wrapper"},[_c('ul',{staticClass:"animations-list"},_vm._l((_vm.data),function(item,key){return _c('li',{key:key,staticClass:"animations-item",class:[
        { relative: key === 0 },
        _vm.startAnimation ? 'animated' : '',
        item.type && item.type === 'mask' ? 'animations-item-mask' : '',
        item.maskDirection ? item.maskDirection : '',
        item.customClasses,
      ],style:(`${
        'transition-duration:' +
        (item.duration ? item.duration + 's;' : 0.6 + 's;') +
        's; ' +
        'transition-delay:' +
        (item.delay ? item.delay + 's;' : 0.35 * (key + 1) + 's;') +
        item.customStyles
      }`)},[_c('img',{staticClass:"animations-img",style:(item.customStylesImage),attrs:{"src":item.src,"alt":item.altText}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }